{
  "title": "Guardian of Faith",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level conjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V",
  "duration": "8 hours",
  "description": [
    "A Large spectral guardian appears and hovers for the duration in an unoccupied space of your choice that you can see within range. The guardian occupies that space and is indistinct except for a gleaming sword and shield emblazoned with the symbol of your deity.",
    "Any creature hostile to you that moves to a space within 10 feet of the guardian for the first time on a turn must succeed on a Dexterity saving throw. The creature takes 20 radiant damage on a failed save, or half as much damage on a successful one. The guardian vanishes when it has dealt a total of 60 damage."
  ],
  "spellLists": ["cleric"]
}
